<template>
  <v-list-item>
    <v-list-item-action>
      <v-radio :value="card"> </v-radio>
    </v-list-item-action>
    <v-list-item-avatar>
      <v-icon>{{ cardIcon }}</v-icon>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>
        <span v-for="(number, index) in 3" :key="index">&middot;&middot;&middot;&middot; &nbsp;</span>
        {{ card.last4 }}
      </v-list-item-title
      >
      <v-list-item-subtitle
        >{{ card.exp_month }} / {{ card.exp_year }}
      </v-list-item-subtitle
      >
    </v-list-item-content>
  </v-list-item>
</template>
<script>
import { mapGetters } from 'vuex';
import SavedCardsMixin from '_GLOBAL/mixins/SavedCardsMixin';

export default {
  name: 'SelectSavedCardListItem',
  data() {
    return {};
  },
  mixins: [SavedCardsMixin],
  props: {
    card: {
      type: Object,
      required: true,
    },
    selected: {
      required: false,
    },
  },

  computed: {
    ...mapGetters(['savedCards']),

    cardIcon() {
      return this.getCardIcon(this.card);
    },
  },

  watch: {},

  methods: {},

  created() {},
  mounted() {},
  updated() {},

  components: {},
};
</script>

<style lang="scss" scoped>
@import '%/scss/_Color.sass';

.fa-cc-visa {
  color: $visa;
}

.fa-cc-mastercard {
  color: $mastercard;
}

.fa-cc-amex {
  color: $amex;
}
</style>
